var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","placement":"top","content":_vm.getTooltipContent(),"hide-after":3000}},[(_vm.error)?_c('i',{staticClass:"el-icon-warning",style:(`color: ${_vm.color}`)}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }